import { channelClient, RequestPolicies } from 'shared/channels';
import { runQueuedMutation } from 'shared/channels/entity';
import { DomainMessagesTypes } from 'shared/domain/messages/message';
import type {
  SharedReportSignedUrlRequest,
  SharedResourceSignedRequestResult,
} from 'shared/download/sharedResourceSignedRequest';
import { reportContract } from './reportContract';
import type { CreateReportModel } from './types/model/createReportPayload';

/** Reports as served by the service worker. */
export const reportClient = {
  /**
   * Resolves once the server accepted the report (it is sent by e-mail later),
   * rejects with the server's error and `messageId`.
   */
  async create(report: CreateReportModel): Promise<void> {
    await runQueuedMutation(
      reportContract,
      'create',
      (uniqueId) => ({ report, uniqueId }),
      DomainMessagesTypes.createdEntity,
      { policy: RequestPolicies.longRunning }
    );
  },

  /** The signed URL(s) of a public report link, or the status the server refused it with. */
  getSignedUrl(request: SharedReportSignedUrlRequest): Promise<SharedResourceSignedRequestResult> {
    return channelClient.request(reportContract, 'getSignedUrl', request, RequestPolicies.read);
  },
};
